import { currentYear } from "../../context/constants";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
const Footer = () => {
    return (
        <footer className="footer">
            <div className="page-container">
                <Row>
                    <Col md={6} className="text-center text-md-start" >{currentYear} © Accruewise </Col>
                    <Col md={6}>
                        <div className="text-md-end footer-links d-none d-md-block">
                            <Link to="https://www.accruewise.in/" target="_blank">www.accruewise.in</Link>
                            {/* <Link to="">Support</Link>
                            <Link to="">Contact Us</Link> */}
                        </div>
                    </Col>
                </Row>
            </div>
        </footer>
    );
};
export default Footer;
